import { observer } from "mobx-react"
import { useCallback, useEffect } from "react"
import { useLocation, useHistory } from "react-router-dom"
import { getOnlyURLParams } from "src/framework/commons/GetOnlyUrlParams"
import { LocalStorage } from "src/framework/commons/LocalStorage"
import { standAlonePage$ } from "src/framework/store/ApiEvents"
import { LoginStore } from "src/framework/store/LoginStore"
import { useObservable } from "src/framework/store/storeUtil"

export const AuthLayout = observer(() => {
  const isLoggedIn = useObservable(LoginStore.isLoggedInSubject());

  const location = useLocation()
  const history = useHistory()

  const login = useCallback(async()=>{
    if (isLoggedIn) return

    const query = new URLSearchParams(location.search)
    const code = query.get('code')
    const session_state = query.get('session_state')
    const tokenUrl = query.get("token")
    const standAlone = query.get("standalone");

    if (standAlone === '1') {
      LocalStorage.set("solar.standAlone", true, true)
      standAlonePage$.next(true)
    }

    if (tokenUrl) {
      return
    }

    let queryStr = getOnlyURLParams(location)

    const uri = `${window.location.origin}${window.location.pathname}${queryStr ? `?${queryStr}` : ''}`

    if (isLoggedIn === undefined) return;

    const token = LoginStore.validateLogin()

    if (token) {
      history.replace(window.location.pathname || "/")
      LoginStore.setLoggedIn(true)
    }

    if (!code && !session_state && !tokenUrl) {
      const contaUrl = await LoginStore.getContaUrlCompleto(uri)
      if (contaUrl) window.location.href = contaUrl
    }

    if (code && session_state) {
      const codeVerifier = LocalStorage.get('solar.code_verifier')
      if (!codeVerifier) return
      LoginStore.doLoginConta(code, session_state, uri, codeVerifier).then(async (error) => {
        if (error) return
        window.location.href = uri
      })
    }
  },[history, isLoggedIn, location])

  useEffect(()=>{
    login()  
  },[login])

  return (
    <div />
  )
})
